<nav class="navbar navbar-expand-lg navbar-dark bg-dark w-100 position-fixed top-0 start-0">
  <div class="container-fluid">
    <a class="navbar-brand d-flex" routerLink=""><img src="/images/logo.webp" alt=""
                                                      class="img-fluid w-100"></a>
    <div class="d-flex align-items-center text-white">
      <a routerLink="/api" class="text-white"><i class="bi bi-link fs-4 me-3"></i></a>
      <a routerLink="/account" class="text-white"><i class="bi bi-gear fs-4 me-3"></i></a>
      <a routerLink="/notifications" class="me-3 text-white notif-badge"><i class="bi bi-bell fs-4"></i>
        <!--<span class="badge">3</span>-->
      </a>
      <a class="text-white" (click)="logout()" role="button"><i class="bi bi-box-arrow-right fs-4"></i></a>
      <button class="btn btn-outline-light d-md-none ms-3 border-0 bg-white" type="button" data-bs-toggle="offcanvas"
              data-bs-target="#sidebar"><i class="bi bi-list text-dark"></i></button>
    </div>
  </div>
</nav>
